import axios from '@axios'
import config from '@core/app-config/api-config'

/** Current maintenance config and the last report of every edge router; settings themselves change via settings-api */
const maintenanceApi = {
  getOverview() {
    // the callers show failures themselves (the global toast would repeat on every poll)
    return axios.get(`${config.host}/maintenance`, { silentError: true })
  },
  /** A one-minute token for <site>/__maintenance/enter?t= */
  issueBypass() {
    return axios.post(`${config.host}/maintenance/bypass`, null, { silentError: true })
  },
}

export default maintenanceApi
